import { Grid, Typography } from "@mui/material";
import React from "react";
import Dashboard from "./Dashboard";
import ClientList from "./Clients/ClientList";

const CallCenterIndex = () => {
  return (
    <Grid container maxWidth="xl" mb={3}>
      <Grid container gap={1} mt={2} justifyContent={"center"}>
        <Grid item xs={12} lg={12}>
          <ClientList />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CallCenterIndex;
